import React, {PureComponent} from 'react';
import camelCase from 'camelcase';
import PT from 'prop-types';
import {Dropdown, Popup, Label} from 'semantic-ui-react';
import classes from './primaryDropdown.css';
import { DropdownOptionsType } from '../../../lib/proptypes/semantic';

// eslint-disable-next-line func-names
const createPopup = function (choices, tooltip, mediaType) {
  return choices.map(item => {
    if (tooltip && item.text.length > 33 & mediaType==='desktop') {
      item.text = (<Popup
        content={item.text}
        key={item.key}
        trigger={<div>{item.text}</div>}
        position="right center"
        style={{
          borderRadius: 0,
          opacity: 0.9,
          padding: '0.5em',
        }}
      />);
    }
    return item;
  });
};

class PrimaryDropdown extends PureComponent {
  render() {
    let {
      label,
      choices,
      activeItem,
      onChange,
      className,
      disabled,
      tooltip, toolTipText, mediaType,
      ...rest
    } = this.props;
    let LabelComponent;
    let hidden = tooltip ? (mediaType === 'desktop' ? true : toolTipText === '' ? true : false) : true
    if (!hidden) {
      LabelComponent =
        <Label
        size={'mini'} as={'a'}
        basic color={'green'}
        pointing
        className={classes.dropdownLabelTooltip}>{toolTipText}
        </Label>
    }
    return (
      <div className={className}>
        <label className={classes.dropdownLabel} htmlFor={camelCase(label)}>{label}</label>
        <Dropdown
          id={camelCase(label)}
          className="primary"
          fluid
          selection
          options={createPopup(choices, tooltip, mediaType)}
          value={activeItem}
          onChange={onChange}
          disabled={disabled}
          {...rest}
        />
        {LabelComponent}
      </div>
    );
  }
}

PrimaryDropdown.propTypes = {
  label: PT.string,
  activeItem: PT.oneOfType([PT.string, PT.number]), // Matches item.value in choices array
  className: PT.string,
  choices: DropdownOptionsType.isRequired,
  onChange: PT.func.isRequired,
  disabled: PT.bool,
  tooltip: PT.bool,
  mediaType: PT.string
};

PrimaryDropdown.defaultProps = {
  label: '',
  className: null,
  activeItem: null,
  onChange: () => true,
  disabled: false,
  tooltip: false,
};

export default PrimaryDropdown;



// WEBPACK FOOTER //
// ./src/app/components/FilterComponents/PrimaryDropdown.js